import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { getBrowserLang, provideTransloco } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { provideTranslocoPersistLang } from '@jsverse/transloco-persist-lang';

import { environment } from '../../environments/environment';
import { languages } from './languages.constant';
import { TranslocoHttpLoaderService } from './transloco-http-loader.service';

const supportedLangs = languages.map(lang => lang.id);

function getDefaultLang(): string {
  const browserLang = getBrowserLang() || '';
  return supportedLangs.includes(browserLang) ? browserLang : supportedLangs[0];
}

export function provideTranslocoApp(): EnvironmentProviders {
  return makeEnvironmentProviders([
    TranslocoHttpLoaderService,
    provideTransloco({
      loader: TranslocoHttpLoaderService,
      config: {
        availableLangs: supportedLangs,
        defaultLang: getDefaultLang(),
        fallbackLang: supportedLangs[0],
        prodMode: environment.production,
        reRenderOnLangChange: true
      }
    }),
    provideTranslocoMessageformat({ locales: supportedLangs }),
    provideTranslocoPersistLang({ storage: { useValue: localStorage } })
  ]);
}
